import reducedMotion from 'helpers/reducedMotion'

export default function ReducedMotion({ swiper, on }) {
  const update = () => {
    const original = swiper.originalParams
    const breakpoint = original.breakpoints?.[swiper.currentBreakpoint] || {}
    const autoplay = breakpoint.autoplay ?? original.autoplay
    const autoplayEnabled = typeof autoplay === 'object' ? autoplay.enabled !== false : autoplay

    swiper.params.speed = reducedMotion.matches ? 0 : (breakpoint.speed ?? original.speed)
    swiper.params.autoplay = {
      ...original.autoplay,
      ...(typeof autoplay === 'object' ? autoplay : {}),
      enabled: !reducedMotion.matches && autoplayEnabled,
    }

    if (reducedMotion.matches || !swiper.enabled || !autoplayEnabled) {
      swiper.autoplay.stop()
      swiper.autoplay.paused = false
      if (reducedMotion.matches && swiper.animating) swiper.transitionEnd()
    } else if (swiper.initialized) {
      swiper.autoplay.start()
    }
  }

  on('beforeInit breakpoint', update)
  on('afterInit', () => reducedMotion.addEventListener('change', update))
  on('destroy', () => reducedMotion.removeEventListener('change', update))
}
